import React from 'react';
import { GhostArticle } from '@minerva-analytics/pantheon';
import { GHOST_API } from '../../ghost';

const colors = {
  body: '#454545',
  link: 'blue',
  title: '#454545',
  header: '#454545',
  quote: '#454545',
  backto: '#454545',
  published: '#454545',
  author: '#454545',
  readtime: '#454545',
};

const fonts = {
  title: 'Inter',
  header: 'Inter',
  body: 'Inter',
  backto: 'Inter',
};

const domain = 'https://internal.minerva.dev/starter-site/';

const Article = () => {
  return (
    <>
      <GhostArticle
        ghostApi={GHOST_API}
        domain={domain}
        colors={colors}
        fonts={fonts}
      />
    </>
  );
};

export default Article;
